import React from "react";

//SimpleBar
import { IChartLowInvProduct } from "src/shared/models/IDashboards.models";
import BootstrapTable from "react-bootstrap-table-next";
import { Type } from "react-bootstrap-table2-editor";
import { NoDataChart } from "./NoDataChart";

interface FormProps {
  details: IChartLowInvProduct[];
  tableTitle: string;
  titleChartNoData: string;
  typeIcon?: boolean;
}

export const TableForDashboardLowInv = React.memo(({details, tableTitle, titleChartNoData, typeIcon = true }: FormProps) => {
  const columns = [
    {
      dataField: "name",
      text: "Producto",
      sort: false,
      style: {
        paddingLeft: 22
      },
      headerStyle: {
        paddingLeft: 22,
        fontSize: 12,
        fontWeight: 500
      },
    },
    {
      dataField: "actualInventory",
      text: "Inventario actual",
      align: "center",
      sort: false,
      style: {},
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
    },   
    {
      dataField: "minStock",
      text: "Inventario mínimo",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
      style: {},
    },
    {
      dataField: "date",
      text: "Última compra",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
      type: 'date',
      formatter: (cell) => {
        let dateObj = cell;
        if (typeof cell !== 'object') {
          dateObj = new Date(cell);
        }
        // Si la fecha es 01/01/1900, colocar sin fecha ""
        if (dateObj.getFullYear() === 1900) {
          return "SIN REGISTRO";
        }
        return `${('0' + dateObj.getDate()).slice(-2)}/${('0' + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`;
      },
      editor: {
        type: Type.DATE
      }
    }, 
    {
      dataField: "vendorName",
      text: "Proveedor",
      sort: false,
      style: {},
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
    },   
  ];

  return (
    <React.Fragment>
      <h5 className="font-size-12 mb-3 ps-4" style={{fontFamily:"Open Sans,sans-serif", marginTop:"20px", color:"#000"}}><strong>{tableTitle}</strong></h5>
      <div className="w-100">
        <BootstrapTable
          key={"productId"}
          // defaultSorted={defaultSorted}
          classes={
            "table align-middle table-nowrap table-condensed table-hover"
          }
          headerClasses="custom-header-horizontal-borders custom-header-blue-background" // Apply custom classes
          rowStyle={{ fontSize: 10 }}
          bordered={false}
          striped={false}
          keyField="productId"
          data={details || []}
          noDataIndication={() => (
            <NoDataChart
              titleChart={tableTitle}
              titleChartNoData={titleChartNoData}
              typeIcon={typeIcon}
              showTitle={false}
            />
          )}
          columns={columns}
          condensed={true}
        />
        </div>
    </React.Fragment>
  );
});
